// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IGalleryWebpage, IGalleryWebpageApiResponse, IGalleryWebpageGetAttrs } from 'interfaces/webpage/gallery'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_baseResponseWebpage } from 'models/extensions/with-helper'

const GalleryWebpageStore = types
  .model('GalleryWebpage')
  .props({
    galleryWebpage_isLoading: types.optional(types.boolean, false),
    galleryWebpage_webpage: withHelper_baseResponseWebpage(),
  })
  .actions(self => ({
    galleryWebpage_SET_LOADING: (payload: boolean): void => {
      self.galleryWebpage_isLoading = payload
    },
    galleryWebpage_SET_GALLERY_WEBPAGE: (payload: IGalleryWebpage): void => {
      self.galleryWebpage_webpage = cast(payload)
    },
    galleryWebpage_CLEAR_GALLERY_WEBPAGE: (): void => {
      self.galleryWebpage_webpage = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch contact us webpage
     *
     * @param {IGalleryWebpageGetAttrs} payload
     *
     * @return {any} any
     */
    galleryWebpage_fetchGalleryWebpage: flow(function* (payload: IGalleryWebpageGetAttrs) {
      self.galleryWebpage_SET_LOADING(true)

      const response: IGalleryWebpageApiResponse = yield self.environment.galleryWebpageApi.galleryWebpage_getGallery(payload)
      if (response.ok) self.galleryWebpage_SET_GALLERY_WEBPAGE(response.res.data)

      self.galleryWebpage_SET_LOADING(false)
    }),
  }))

export const createGalleryWebpageStoreDefaultModel = () => types.optional(GalleryWebpageStore, {})
